// Workspace resolution pro PWA — kazda Routera instance ma svuj workspace.
//
// Logika:
//   1. Kdyz je URL path neprazdny (napr. /work/), workspace = prvni segment.
//      Zaroven se ulozi do localStorage (preference pro nasledne otevreni
//      installed PWA, kde start_url je '/').
//   2. Kdyz URL path je prazdny ('/'), pouzij hodnotu z localStorage.
//   3. Fallback: 'default'.
//
// Zaroven exposuje API klienta s X-Workspace-Id headerem.

const STORAGE_KEY = "routera.workspace";

function _parsePathWorkspace(): string | null {
  if (typeof window === "undefined") return null;
  const seg = window.location.pathname.split("/").filter(Boolean)[0];
  if (!seg) return null;
  // Validace — povolime jen [a-z0-9-]+
  if (!/^[a-z0-9-]+$/i.test(seg)) return null;
  return seg.toLowerCase();
}

export function resolveWorkspace(): string {
  if (typeof window === "undefined") return "default";
  const fromPath = _parsePathWorkspace();
  if (fromPath) {
    try {
      window.localStorage.setItem(STORAGE_KEY, fromPath);
    } catch {
      /* ignore quota */
    }
    return fromPath;
  }
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    if (stored) return stored;
  } catch {
    /* ignore */
  }
  return "default";
}

/** Aktualni workspace — synchronni getter (z localStorage / URL). */
export const WORKSPACE_ID = resolveWorkspace();

/** Basename pro IonReactRouter — '/work' nebo '' pro default. */
export const WORKSPACE_BASENAME =
  WORKSPACE_ID && WORKSPACE_ID !== "default" && _parsePathWorkspace()
    ? `/${WORKSPACE_ID}`
    : "";
